import React from 'react';

import { Stack, Typography, makeStyles } from '@gogame/components';

const useStyles = makeStyles(() => ({
  root: {
    padding: '4px 14px 0',
  },
}));

const ErrorMessage = ({ children }) => {
  const classes = useStyles();

  return (
    <Stack className={classes.root}>
      <Typography variant={'caption'} color={'error'}>
        {children}
      </Typography>
    </Stack>
  );
};

export default ErrorMessage;
